package com.anjuros.website.components

import com.anjuros.website.components.language.Language
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.templates.mix.modules.MIXUrlParam
import kotlinx.browser.localStorage
import kotlinx.browser.window
import org.w3c.dom.url.URL

fun getParam(param: String): String {
    return localStorage.getItem(param)?:""
}

fun setParam(key: String, value: String) {
    localStorage.setItem(key, value)
}

fun removeParam(key: String) {
    localStorage.removeItem(key)
}

fun setSectionId(sectionId: String) {
    val url = URL(window.location.href)
    url.hash = sectionId   // automatically becomes "#sectionId"

    window.history.replaceState(null, "", url.toString())
}

/** The site is English only. */
fun detectLanguage(): Language = Language.EN

fun detectMode2(): UiMode {
    val modeCode =  localStorage.getItem(MIXUrlParam.MODE.paramName)?:"N"
    return when(modeCode){
        "P" -> UiMode.PLACEHOLDER
        else -> UiMode.NORMAL
    }
}

fun detectMode(): UiMode? {
    val modeCode =  localStorage.getItem(MIXUrlParam.MODE.paramName)
    return when(modeCode){
        "P" -> UiMode.PLACEHOLDER
        "N" -> UiMode.NORMAL
        else-> null
    }
}

fun changeMode(uiMode: UiMode){
    localStorage.setItem(MIXUrlParam.MODE.paramName, uiMode.value)
}
